<template>
   <div class="dashboard">
      <div class="segment small-padding">
         <div class="filter-date card">
            <div class="row">
               <div class="col-md-7">
                  <div class="form-label">Select a date</div>
                  <DatePicker 
                     type="daterange" 
                     v-model="dateRange" 
                     format="dd-MM-yyyy" 
                     placeholder="Select a Date Range"
                     :options="options"
                     :start-date="new Date()">
                  </DatePicker>
               </div>
               <div class="col-md-3">
                  <div class="btn btn-primary btn-long" @click="fetchVisualData('main')">
                     Filter <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
               <div class="col-md-2">
                  <div class="btn btn-primary btn-long" @click="downloadChartReport({name: 'Main Dashboard'})">
                     Download Report <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="row top-cards">
         <div class="no-content" v-if="visuals.length === 0">
            <div class="icon"><i class="fa fa-chart-pie"></i></div>
            <div class="text">No Visualizations Configured</div>
         </div>

         <div class="no-padding" v-else v-for="(visual,i) in visuals" :key="i" :class="visual.class">
            <div class="stat-card-stat segment segment-right" v-if="visual.type === 'stat_card'">
               <router-link v-if="visual.dashboard_link" class="" :to="{name: 'Dashboards-View_Dashboard' || 'Dashboard', params: {dashboard_id: visual.dashboard_link}}">
                  <div class="loading-box" v-if="visual.is_loading">
                     <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                  </div>
                  <div class="row">
                     <div class="col-12">
                        <div class="custom-title-wrap">
                           <div class="clearfix span">
                              <div class="l icon-side">
                                 <i class="big-icon fa" :class="visual.icon"></i>
                              </div>
                              <div class="l text-side">
                                 <div class="padded-title text-uppercase">{{visual.name}}</div>
                                 <h3 class="">{{utils.numberWithCommas(visual.data.count)}}</h3>
                              </div>
                           </div>
                           <div class="tx-bottom clearfix">
                              <div class="percentage l" :class="visual.data.difference_percentage > 1 ? 'tx-success' : 'tx-danger'">
                                 <div class="clearfix">
                                    <div class="fa l" :class="visual.data.difference_percentage > 1 ? 'fa-chevron-up' : 'fa-chevron-down'"></div>
                                    <div class="val l">{{Math.abs(visual.data.difference_percentage)}}%</div>
                                 </div>
                              </div>
                              <div class="l small-text">(Last {{visual.last_days}} Days)</div>
                           </div>
                        </div>
                     </div>
                  </div>
               </router-link>
               <div v-else>
                  <div class="loading-box" v-if="visual.is_loading">
                     <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                  </div>
                  <div class="row">
                     <div class="col-12">
                        <div class="custom-title-wrap">
                           <div class="clearfix span">
                              <div class="l icon-side">
                                 <i class="big-icon fa" :class="visual.icon"></i>
                              </div>
                              <div class="l text-side">
                                 <div class="padded-title text-uppercase">{{visual.name}}</div>
                                 <h3 class="">{{utils.numberWithCommas(visual.data.count)}}</h3>
                              </div>
                           </div>
                           <div class="tx-bottom clearfix">
                              <div class="percentage l" :class="visual.data.difference_percentage > 1 ? 'tx-success' : 'tx-danger'">
                                 <div class="clearfix">
                                    <div class="fa l" :class="visual.data.difference_percentage > 1 ? 'fa-chevron-up' : 'fa-chevron-down'"></div>
                                    <div class="val l">{{Math.abs(visual.data.difference_percentage)}}%</div>
                                 </div>
                              </div>
                              <div class="l small-text">(Last {{visual.last_days}} Days)</div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            
            <div class="card card-shadow" v-if="['line','pie','doughnut','area','bar','calendar','calendar_week','region_map'].includes(visual.type)" :ref="visual._id">
               <div class="title-box">
                  <div class="clearfix">
                     <div class="chart-title l">
                        <div class="c-title">{{visual.name}}</div>
                        <div class="desc">{{visual.description}}</div>
                     </div>
                     <router-link v-if="visual.dashboard_link" class="link r" :to="{name: 'Dashboards-View_Dashboard' || 'Dashboard', params: {dashboard_id: visual.dashboard_link}}">
                        View More
                     </router-link>
                     <i class="fa fa-download small-btn" @click="downloadChart({ref: $refs[visual._id],name: visual.name})"></i>
                  </div>
               </div>
               <div class="chart-box" v-if="visual.data" :class="visual.is_loading ? 'loading' : ''" :id="visual.name.toLowerCase().split(' ').join('_')">
                  <div class="loading-box" v-if="visual.is_loading">
                     <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                  </div>
                  <v-chart :option="chartOptions[visual.name.toLowerCase().split(' ').join('_')]"></v-chart>
               </div>
            </div>

            <div class="card card-shadow" v-if="visual.type === 'map'" :ref="visual._id">
               <div class="title-box">
                  <div class="clearfix">
                     <div class="chart-title l">
                        <div class="c-title">{{visual.name}}</div>
                        <div class="desc">{{visual.description}}</div>
                     </div>
                     <router-link v-if="visual.dashboard_link" class="link r" :to="{name: 'Dashboards-View_Dashboard' || 'Dashboard', params: {dashboard_id: visual.dashboard_link}}">
                        View More
                     </router-link>
                     <!-- <i class="fa fa-download small-btn" @click="downloadChart({ref: $refs[visual._id],name: visual.name})"></i> -->
                  </div>
               </div>
               <div class="chart-box" :class="visual.is_loading ? 'loading' : ''">
                  <div class="loading-box" v-if="visual.is_loading">
                     <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                  </div>
                  <div class="map" :id="visual.name.toLowerCase().split(' ').join('_')"></div>
               </div>
            </div>

            
         </div>
      </div>
   </div>
</template>

<script>
import dashboard from "./dashboard.store";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart,LineChart,BarChart,HeatmapChart } from "echarts/charts";
import {
   TitleComponent,
   TooltipComponent,
   DataZoomComponent,
   DataZoomInsideComponent,
   ToolboxComponent,
   MarkPointComponent,
   MarkLineComponent,
   LegendComponent
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

use([
   CanvasRenderer,
   PieChart,
   HeatmapChart,
   BarChart,
   LineChart,
   DataZoomComponent,
   DataZoomInsideComponent,
   ToolboxComponent,
   MarkPointComponent,
   MarkLineComponent,
   TitleComponent,
   TooltipComponent,
   LegendComponent
]);

export default {
   provide: {
      [THEME_KEY]: "light"
   },
   components:{
      VChart,
      DatePicker: () => import("clarks/components/date-picker/index"),
   },
   beforeDestroy () {
      this.$store.unregisterModule('dashboard')
      Event.$off('component:reload')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('dashboard',dashboard,this.$store)
      Event.$on('component:reload', () => {
         this.$forceUpdate()
      })
   },
   data() {
      return{
         utils,
         dateRange: [],
      }
   },
   computed: {
      ...mapGetters([
         'usersCount',
         'chartOptions',
         'options',
         'visuals',
         'date',
         'loading',
      ]),
   },
   methods: {
      ...mapActions([
         'fetchMainDashboardData',
         'downloadChart',
         'downloadChartReport',
      ]),
      async fetchVisualData(){
         if(typeof this.dateRange[0].getMonth === 'function'){
            this.dateRange[0] = moment(this.dateRange[0]).format('DD-MM-YYYY')
            this.dateRange[1] = moment(this.dateRange[1]).format('DD-MM-YYYY')
         }

         this.$store.commit('date',this.dateRange)
         await this.fetchMainDashboardData();
      },
      
   },
   async mounted(){
      utils.registerModule('dashboard',dashboard,this.$store);
      this.dateRange = this.date
      await this.fetchMainDashboardData();
      this.$forceUpdate();
      console.log(this.chartOptions)
   }
}
</script>

<style lang="scss">
@import '../../../../styles/dashboard.scss';

</style>